export default __webpack_public_path__ + "static/6-1--b7117824dcffdb1f1cc1b6a04f577274.png";